import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import './i18n'
import App from './app'
import AuthProvider from './components/AuthProvider'
import UpdateMomentLocaleHoC from './components/UpdateMomentLocaleHoC'

console.log('emulators', process.env.REACT_APP_FIREBASE_EMULATORS)

const AppWithProviders = () => {
  return (
    <AuthProvider>
      <Suspense fallback={<div />}>
        <UpdateMomentLocaleHoC>
          <App />
        </UpdateMomentLocaleHoC>
      </Suspense>
    </AuthProvider>
  )
}

const rootElement = document.getElementById('root')

if (process.env.REACT_APP_BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
  })
  const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

  ReactDOM.render(
    <ErrorBoundary>
      <AppWithProviders />
    </ErrorBoundary>,
    rootElement
  )
} else {
  ReactDOM.render(<AppWithProviders />, rootElement)
}
